import {Navigate, Outlet} from 'react-router-dom';
import {Spinner} from 'components/ui/Spinner';
import {observer} from 'mobx-react-lite';
import {AppRoutePaths, AuthRoutePaths} from 'routing/Routes';
import {appState} from 'store/AppStore';

export const PrivateRoutes = observer((): JSX.Element => {
  const {isLoggedIn, isLoading} = appState;

  if (isLoading) {
    return (
      <div className="bg-transparent h-screen flex justify-center items-center">
        <Spinner />
      </div>
    );
  }
  return isLoggedIn ? <Outlet /> : <Navigate to={AuthRoutePaths.signIn.url} />;
});

export const PublicRoutes = observer((): JSX.Element => {
  const {isLoggedIn} = appState;
  return !isLoggedIn ? <Outlet /> : <Navigate to={AppRoutePaths.dashboard.url} />;
});
